import {
  type DetailedBagProduct,
  type DetailedBagSellerInfo,
  type DetailedBagSummary,
  type BasicBag,
  type DetailedBagBanners,
  type DetailedBagBundle,
} from './aliases';

type OptimisticBag<T> = Partial<T> & { is_optimistic: boolean };

export type OptimisticBagDetailedProduct = OptimisticBag<DetailedBagProduct>;
export type OptimisticBagDetailedSellerInfo =
  OptimisticBag<DetailedBagSellerInfo> & {
    id: number;
  };
export type OptimisticBagDetailedSummary = OptimisticBag<DetailedBagSummary>;

export type BagDetailedSellerCache = {
  seller: DetailedBagSellerInfo | OptimisticBagDetailedSellerInfo;
  products: (DetailedBagProduct | OptimisticBagDetailedProduct)[];
  summary: DetailedBagSummary | OptimisticBagDetailedSummary;
  bundle?: DetailedBagBundle;
  banners?: DetailedBagBanners;
};

export type OptimisticDetailedBag = {
  sellers: BagDetailedSellerCache[];
};

export function isOptimisticSeller(
  seller: BagDetailedSellerCache['seller']
): seller is OptimisticBagDetailedSellerInfo {
  return 'is_optimistic' in seller && seller.is_optimistic;
}

export function isOptimisticProduct(
  product: DetailedBagProduct | OptimisticBagDetailedProduct
): product is OptimisticBagDetailedProduct {
  return 'is_optimistic' in product && product.is_optimistic;
}

export function hasOptimisticProducts(
  products: (DetailedBagProduct | OptimisticBagDetailedProduct)[]
) {
  return products.some((product) => isOptimisticProduct(product));
}

export function isOptimisticSummary(
  summary: BagDetailedSellerCache['summary']
): summary is OptimisticBagDetailedSummary {
  return 'is_optimistic' in summary && summary.is_optimistic;
}

export type BagTrackingTypes = 'bag' | 'quickAccessBag';

export type BagViewArgs = {
  productIds: number[];
  soldProductIds: number[];
};

export type BagBasicQueryResult = BasicBag & {
  count: number;
};
